import React, {useEffect, useState} from 'react';
import {ThemeTabs} from '../coupons/ThemeTabs';
import {useTranslation} from 'react-i18next';
import {SummaryBlock} from '../coupons/Lists/SummaryBlock';
import {ReactComponent as CloseIcon} from '../coupons/Lists/assets/close.svg';
import {
    ADD_COUPON_EVENT,
    couponType,
    getMarketLimitAsync,
    HIDE_NEED_CONFIRM_DIALOG,
    REMOVE_NEED_CONFIRM_COUPON_EVENT,
    SET_CURRENT_COUPON_TYPE
} from "../../store/spirs/actions";
import {useDispatch, useSelector} from "react-redux";
import {couponTypeArray, StoreType} from "../../store/spirs/types";
import {Desktop} from "../adaptive/Desktop";
import {Mobile} from "../adaptive/Mobile";
import {AddToCouponDialog} from "./AddToCouponDialog";
import {CouponThemeTabs} from "./CouponThemeTabs";


type AddToCouponProps = {
    anchorElId: string | null;
};

export const AddToCoupon: React.FC<AddToCouponProps> = ({anchorElId}) => {
    const [anchorEl, setAnchorEl] = useState<Element | null>(null);

    useEffect(() => {
        if (anchorElId === null) {
            setAnchorEl(null);
        } else {
            setAnchorEl(document.getElementById(anchorElId));
        }
    }, [anchorElId]);


    return (<>
            <Desktop>
                <AddToCouponDialog anchorElId={anchorElId} anchorEl={anchorEl} isOpen={anchorEl !== null} className="w-[416px]">
                    <Content/>
                </AddToCouponDialog>
            </Desktop>
            <Mobile>
                {anchorEl !== null && (
                    <div className="fixed bottom-0 w-full z-[99]">
                        <Content/>
                    </div>
                )}
            </Mobile>
        </>
    );
};

const Content: React.FC = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const currentCouponType = useSelector((state: StoreType) => state.spirs.coupons.currentCouponType);
    const needConfirmEvent = useSelector((state: StoreType) => state.spirs.coupons.needConfirmEvent);

    function handleChange(tabs: couponType) {
        dispatch(SET_CURRENT_COUPON_TYPE(tabs));
    }

    function handleAddToCoupon() {
        if (needConfirmEvent !== undefined) {
            dispatch(ADD_COUPON_EVENT(needConfirmEvent));
            dispatch(HIDE_NEED_CONFIRM_DIALOG());
            dispatch(getMarketLimitAsync.request({marketId: needConfirmEvent.marketId, fixtureId: needConfirmEvent.fixtureId}));
        }
    }

    function handleClose() {
        dispatch(REMOVE_NEED_CONFIRM_COUPON_EVENT());
        dispatch(HIDE_NEED_CONFIRM_DIALOG());
    }

    const eventsCountByType = useSelector((state: StoreType) => couponTypeArray.reduce((ac, cT) => ({
            ...ac,
            [cT]: state.spirs.coupons[cT].length
        }), {EXPRESS: 0, ORDINAR: 0, SYSTEM: 0})
    );

    const tabs = couponTypeArray.map(couponType => ({
        tabId: couponType,
        tabTitle: t('coupons.' + couponType + '.tabTitle'),
        newEventsCount: eventsCountByType[couponType]
    }));

    return (
        <React.Fragment>
            <div className="max-mobile:hidden">
                <span />
            </div>
            <div className="w-[100%] tablet:w-[416px] flex flex-col bg-[#272D33] p-[8px] rounded-xl border border-[#EACD40] shadow-[0_0_10px_2px_black]">
                <span>{t("enableEventIn")}:</span>

                <CouponThemeTabs
                    handleChange={handleChange}
                    value={currentCouponType}
                    tabs={tabs}
                    containerMaxWidth
                />


                <hr className="h-[1px] w-full bg-[#292F34] border-none"/>
                <SummaryBlock/>

                <h5>
                    <div className="flex flex-nowrap justify-between pt-[12px]">
                        <div className="flex w-full">
                            <button onClick={handleAddToCoupon} className="mx-[8px] desktop:mx-[10px] rounded-lg bg-yellow-400 text-black px-[18%] w-full hover:bg-yellow-300">
                                <h5>
                                    {t("addToCoupon")}
                                </h5>
                            </button>
                        </div>
                        <div onClick={handleClose} className="rounded-full">
                            <div className="flex justify-center items-center rounded-full min-w-[32px] h-[32px] desktop:min-w-[42px] desktop:h-[42px] bg-[#272D33]">
                                <CloseIcon className="notebook:scale-75"/>
                            </div>
                        </div>
                    </div>
                </h5>
            </div>
        </React.Fragment>
    )
};
